import { Observable, of, throwError } from 'rxjs';
import { endpoints } from '@app/constants';
import { mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GetConsentAgreementPayload, GetPaymentMethodPayload, GetPaymentMethodResponse, SaveStoredCredentialConsentPayload, StoredCredentialConsentResponse } from './consent-agreement.models';
import { HttpService } from '@app/core/services/http';

@Injectable({
  providedIn: 'root'
})
export class ConsentAgreementService {
  constructor(
    private httpService: HttpService,
  ) { }

  public getConsentAgreementContent = (payload: GetConsentAgreementPayload): Observable<any> => {
    return this.httpService
      .setResponseType('text')
      .post({ url: `${endpoints.zuora}${endpoints.storedCredentialConsent}${endpoints.getContent}`, body: payload })
      .pipe(
        mergeMap(this.handleGetConsentAgreementContent),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  public getPaymentMethodAndStoreAgreement = (payload: GetPaymentMethodPayload): Observable<StoredCredentialConsentResponse> => {
    return this.httpService
      .get({ url: `${endpoints.zuora}${endpoints.paymentMethod}${payload.paymentMethodId}` })
      .pipe(
        mergeMap((response: GetPaymentMethodResponse) => this.storedCredentialConsent(response, payload)),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  private storedCredentialConsent = (response: GetPaymentMethodResponse, metaData: GetPaymentMethodPayload): Observable<StoredCredentialConsentResponse> => {
    let payload: SaveStoredCredentialConsentPayload = {
      languageCode: metaData.language,
      paymentMethodId: metaData.paymentMethodId,
      clientDomain: metaData.clientDomain,
      lastFourCardNumber: response.cardNumber.replace(/(\*)/g, "")
    }
    return this.httpService
      .post({ url: `${endpoints.zuora}${endpoints.storedCredentialConsent}${endpoints.save}`, body: payload })
      .pipe(
        mergeMap(this.handleStoredCredentialConsent),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  private handleGetConsentAgreementContent(response: any): Observable<any> {
    return of(response);
  }

  private handleStoredCredentialConsent(response: StoredCredentialConsentResponse): Observable<StoredCredentialConsentResponse> {
    return of(response);
  }
}
